import React from 'react'
import Chip from '@mui/material/Chip'

const FALLBACK_STATUS_TONE = {
  bgcolor: '#ECEFF3',
  color: '#5F6B7A'
}

export default function MobileStatusChip({
  statusUI,
  label,
  className,
  sx = {}
}) {
  const resolvedLabel = statusUI?.label || label || '-'
  const resolvedClassName = statusUI?.className || className || ''

  return (
    <Chip
      label={resolvedLabel}
      size="small"
      className={resolvedClassName}
      sx={{
        minHeight: 28,
        height: 'auto',
        borderRadius: 999,
        fontSize: 14,
        fontWeight: 700,
        ...(resolvedClassName ? {} : FALLBACK_STATUS_TONE),
        '& .MuiChip-label': {
          px: 1.25,
          py: 0.25,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        ...sx
      }}
    />
  )
}
